function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.31 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.25,6.16h-69A4.54,4.54,0,0,0,6.8,10.75V41.8a1.75,1.75,0,1,0,3.49,0v-31a1,1,0,0,1,1-1h69a1,1,0,0,1,1,1v69.5a1,1,0,0,1-1,1h-69a1,1,0,0,1-1-1V56a3.36,3.36,0,0,0,1.53-2.83,3.32,3.32,0,0,0-3.27-3.36,3.33,3.33,0,0,0-3.28,3.36A3.38,3.38,0,0,0,6.8,56v24.3a4.54,4.54,0,0,0,4.48,4.59h69a4.54,4.54,0,0,0,4.48-4.59V10.75A4.54,4.54,0,0,0,80.25,6.16Z",
    style: {
      fill: "#006098"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.15,63.9V30.27h4.7V63.9Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.42,48a18.47,18.47,0,0,1,.18-2.69,6.57,6.57,0,0,1,.69-2.18,6.39,6.39,0,0,1,2.37-2.5,7.07,7.07,0,0,1,3.76-.94,7.05,7.05,0,0,1,3.75.94,6.49,6.49,0,0,1,2.38,2.5,6.57,6.57,0,0,1,.69,2.18A18.47,18.47,0,0,1,52.42,48v7.89a18.67,18.67,0,0,1-.18,2.69,6.39,6.39,0,0,1-3.07,4.67,7.9,7.9,0,0,1-7.51,0,6.39,6.39,0,0,1-2.37-2.5,6.51,6.51,0,0,1-.69-2.17,18.67,18.67,0,0,1-.18-2.69Zm4.7,8.64a3,3,0,0,0,.62,2.06,2.42,2.42,0,0,0,3.36,0,3,3,0,0,0,.62-2.06v-9.4a3,3,0,0,0-.62-2,2.39,2.39,0,0,0-3.36,0,2.92,2.92,0,0,0-.62,2Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.94,63.9V34.8H51.5V30.27H67.07V34.8H61.64V63.9Z",
    style: {
      fill: "#0075c9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotIcon);
export default __webpack_public_path__ + "static/media/iotIcon.3880bf2f.svg";
export { ForwardRef as ReactComponent };